export const systems = "Systems"
export const symptoms = "Complaints"
export const history = "History"
export const otherSymptoms = "OtherSymptoms"
export const faqs = "FAQs"
export const suggestions = "Suggestion"
export const examinations = "Examinations"
export const impressions = "Impressions"
export const treatment_plans = "TreatmentPlans"
export const reports = "Reports"
export const users = "Users"
export const locations = "Locations"